/* eslint-disable new-cap */
/* eslint-disable no-new */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-throw-literal */
/**
 * Simple Single User Session Client method.
 * @version 1.3.1
 * @author nuri cheung <nuri0609.c@gmail.com>
 */
const keepAliveUrl = 'https://singleusersession.eventxtra.com/keepAlive';
const connectSingleSessionUrl = 'https://singleusersession.eventxtra.com/login';
const header = {
  'Content-Type': 'application/json',
};
const userSessionKeepAliveTime = 10; // seconds

let keepAliveBody = '';
let sessionToken = '';
let _authToken = '';

function keepAliveSingleSessionService() {
  const start = Date.now();
  const times = [];
  let isSuccess = true;
  setTimeout(function run() {
    times.push(Date.now() - start);

    if (start + userSessionKeepAliveTime * 1000 < Date.now()) {
      fetch(keepAliveUrl, {
        method: 'POST',
        redirect: 'follow',
        headers: header,
        body: keepAliveBody,
      })
        .then((response) => {
          if (response.status !== 200) {
            throw 'server connect failed';
          }
          return response.json();
        })
        .then((jsonData) => {
          isSuccess = jsonData.success;
          if (!isSuccess) {
            throw jsonData.message;
          } else {
            return keepAliveSingleSessionService();
          }
        })
        .catch((err) => {
          if (err === 'session expired') {
            localStorage.removeItem('sessionToken');
            // eslint-disable-next-line no-use-before-define
            connectSingleSessionService(_authToken, true);
          } else if (err === 'kickCallback') {
            localStorage.removeItem('sessionToken');
            const kickCallbackEvent = new Event('kickCallback', { bubbles: true, cancelable: true });
            return window.dispatchEvent(kickCallbackEvent);
          }
          const connectFailedEvent = new Event('server connect failed', { bubbles: true, cancelable: true });
          return window.dispatchEvent(connectFailedEvent);
        });
    } else {
      setTimeout(run);
    }
  });
}

// eslint-disable-next-line consistent-return
function connectSingleSessionService(authToken, isKick = false) {
  const url = connectSingleSessionUrl;
  _authToken = authToken;
  sessionToken = localStorage.getItem('sessionToken');
  if (sessionToken) {
    keepAliveBody = JSON.stringify({
      sessionToken,
      authToken: _authToken,
    });
    return new keepAliveSingleSessionService();
  }
  fetch(url, {
    method: 'POST',
    redirect: 'follow',
    headers: header,
    body: JSON.stringify({
      authToken: _authToken,
      kick: isKick,
    }),
  })
    .then((response) => {
      if (response.status !== 200) {
        throw 'server connect failed';
      }
      return response.json();
    })
    .then((jsonData) => {
      const isSuccess = jsonData.success;
      if (isSuccess) {
        sessionToken = jsonData.sessionToken;
        keepAliveBody = JSON.stringify({
          sessionToken,
          authToken: _authToken,
        });
        localStorage.setItem('sessionToken', sessionToken);
        new keepAliveSingleSessionService();
      } else {
        throw 'another device logged in';
      }
    })
    .catch((err) => {
      if (err === 'another device logged in') {
        localStorage.removeItem('sessionToken');
        const otherDeviceLoggedInEvent = new Event('another device logged in', { bubbles: false, cancelable: true });
        return window.dispatchEvent(otherDeviceLoggedInEvent);
      }
      if (err === 'kickCallback') {
        localStorage.removeItem('sessionToken');
        const kickCallbackEvent = new Event('kickCallback', { bubbles: false, cancelable: true });
        return window.dispatchEvent(kickCallbackEvent);
      }
      const connectFailedEvent = new Event('server connect failed', { bubbles: true, cancelable: true });
      return window.dispatchEvent(connectFailedEvent);
    });
}

export default connectSingleSessionService;
